import { Component, Inject, Injector, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AbstractComponent } from '../../../../commons/abstract.component';
import { SettingsWebhook, SettingsWebhookItem } from '../../../../models/settings-webhook.model';
import { AbstractControl, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';

export interface SettingsWebhookFormComponentData {
  settingsWebhook: SettingsWebhook;
  settingsWebhookItem: SettingsWebhookItem;
}

@Component({
    selector: 'settings-webhook-form-component',
    // templateUrl: './settings-webhook-form.component.html',
    templateUrl: './settings-webhook-form.v2.component.html',
    styleUrls: ['./settings-webhook-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SettingsWebhookFormComponent extends AbstractComponent implements OnInit {

  settingsWebhookItem: SettingsWebhookItem = <SettingsWebhookItem>{};
  
  showNameTooltip = false;
  showUrlTooltip = false;
  showEventTooltip = false;
  showWebhookInfo = false;

  constructor(
    injector: Injector,
    public dialogRef: MatDialogRef<SettingsWebhookFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: SettingsWebhookFormComponentData,
  ) {
    super(injector);
  }

  ngOnInit() {
    this.loading = false;
    this.setupForm();
    this.settingsWebhookItem = this.data.settingsWebhookItem || <SettingsWebhookItem>{};
    this.formGroup.patchValue(this.settingsWebhookItem);
  }

  setupForm() {
    this.formGroup = this.formBuilder.group({
      name: ['', [Validators.required]],
      url: ['', [Validators.required, Validators.pattern(this.domainHttpRegex)]],
      events: [[], [Validators.required]],
      actived: [true],
    });
    this.formGroup.valueChanges.subscribe(value => {
      Object.assign(this.settingsWebhookItem, value);
    });
  }

  onSubmit() {
    if (!this.formGroup.valid) {
      this.validateAllFormFields(this.formGroup);
      return;
    };
    this.dialogRef.close(this.settingsWebhookItem);
  }

  close(): void {
    this.dialogRef.close();
  }

  toggleNameTooltip(): void {
    this.showNameTooltip = !this.showNameTooltip;
  }

  toggleUrlTooltip(): void {
    this.showUrlTooltip = !this.showUrlTooltip;
  }

  toggleEventTooltip(): void {
    this.showEventTooltip = !this.showEventTooltip;
  }

  toggleWebhookInfo(): void {
    this.showWebhookInfo = !this.showWebhookInfo;
  }
}
